export function kebabToSentence(text: string) {
  const temp = text.replace(/-/g, ' ');
  return temp.slice(0, 1).toUpperCase() + temp.slice(1);
}

export function kebabToPascal(text: string) {
  return text.replace(/(^\w|-\w)/g, clearAndUpper);
}

function clearAndUpper(text: string) {
  return text.replace(/-/, '').toUpperCase();
}

export function capitalizeFirstLetter(text: string) {
  return text.slice(0, 1).toUpperCase() + text.slice(1);
}
